/**
 * Text Personalization
 * Replaces placeholder text with name from URL parameters
 * URL: ?name=John&Doe → "John Doe"
 */

(() => {
    // Get name from URL
    const params = new URLSearchParams(window.location.search);
    const allParams = Array.from(params.entries());
    const nameIndex = allParams.findIndex(([key]) => key === 'name');

    if (nameIndex === -1) return;

    let name = allParams[nameIndex]?.[1];
    if (!name) return;

    // Only append next param as last name if it has no value (e.g., ?name=John&Doe)
    const nextParam = allParams[nameIndex + 1];
    if (nextParam && !nextParam[1]) {
        name += ' ' + nextParam[0];
    }

    name = name.trim();

    // Replace text in all personalized elements
    document.querySelectorAll('[data-personalized]').forEach(el => {
        if (!(el instanceof HTMLElement)) return;

        // Get placeholder, decode HTML and strip tags
        const temp = document.createElement('div');
        temp.innerHTML = el.dataset.placeholder || '';
        const placeholder = temp.textContent?.trim();

        if (!placeholder) return;

        // Replace in text nodes
        const regex = new RegExp(placeholder.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');
        const walk = (/** @type {Node} */ node) => {
            if (node.nodeType === 3 && node.nodeValue && regex.test(node.nodeValue)) {
                node.nodeValue = node.nodeValue.replace(regex, name);
            } else {
                node.childNodes.forEach(walk);
            }
        };
        walk(el);
    });

    // Unhide any buttons marked to show after personalization
    document.querySelectorAll('[data-personalized-cta]')
        .forEach(el => {
            if (el instanceof HTMLElement) {
                el.classList.remove('hidden');
            }
        });
})();

